define('SearchSpring.Mapper.Item', [
    'underscore'
], function SearchSpringMapperItem(
    _
) {
    'use strict';

    var itemType = {
        'assemblyitem': 'Assembly',
        'descriptionitem': 'Description',
        'discountitem': 'Discount',
        'giftcertificateitem': 'GiftCert',
        'inventoryitem': 'InvtPart',
        'itemgroup': 'Group',
        'kititem': 'Kit',
        'markupitem': 'Markup',
        'noninventoryitem': 'NonInvtPart',
        'otherchargeitem': 'OthCharge',
        'paymentitem': 'Payment',
        'serviceitem': 'Service',
        'subtotalitem': 'Subtotal'
    };

    window.searchspringMappers = window.searchspringMappers || [];

    return function mapItem(data) {
        var newData = {};
        _.extend(newData, data, {
            itemimages_detail: { urls: [{ altimagetext: '', url: data.ss_image }] },
            ispurchasable: true,
            isfullfilable: data.isfulfillable === '1',
            isonline: data.isonline === '1',
            displayname: data.name,
            onlinecustomerprice_detail: {
                onlinecustomerprice_formatted: _.formatCurrency(data.price),
                onlinecustomerprice: parseFloat(data.price)
            },
            custitem_sca_store: data.custitem_sca_store && data.custitem_sca_store.join(','), // reinsert silly sca bug
            priceRange: data.ss_price_range,
            pricelevel1: parseFloat(data.msrp).toFixed(2),
            pricelevel1_formatted: _.formatCurrency(parseFloat(data.msrp).toFixed(2)),
            itemtype: itemType[data.recordtype]
        });
        _.each(window.searchspringMappers, function newMapper(mapper) {
            mapper(newData);
        });

        return newData;
    };
});
